var VariantItem = /** @class */ (function () {
    /**
     * Creates a selectable input item
     *
     * @param index Item index
     * @param id Item id
     * @param date The date of the offer variant (pre-formatted)
     * @param price The price value
     * @param priceString The price value incl. currency symbol
     * @param bestPrice Whether the given offer variant is the best price (default : false)
     * @param available Whether any offer variant for the given date available (default : true)
     * @param selected Whether this offer variant is pre-selected (default : false)
     */
    function VariantItem(index, id, date, price, priceString, bestPrice, available, selected) {
        /**
         * Whether the given offer variant is the best price (default : false)
         */
        this.bestPrice = false;
        /**
         * Whether the given offer variant is the best price in the travel period (default : false)
         */
        this.travelPeriodPriceHighlight = false;
        /**
         * Whether any offer variant for the given date available (default : true)
         */
        this.available = true;
        /**
         * Whether this offer variant is pre-selected (default : false)
         */
        this.selected = false;
        this.index = index;
        this.id = id;
        this.date = date;
        this.price = price;
        this.priceString = priceString;
        this.bestPrice = bestPrice;
        this.available = available;
        this.selected = selected;
    }
    return VariantItem;
}());
export default VariantItem;
